import apis from "../../../api";
import { errorTypes } from "../../../utils/errorTypes";
import { videoUploadStatus } from "../../../utils/videoUploadStatus";
import loaders from "../actionCreators/loadersActionCreator";
import {
  getClassDetailsByIdAction,
  getManageTranscriptionAction,
  getMyDraftsAction,
  getPublishedByMeAction,
  getPublishedByOthersAction,
  setShowVideoUploadListPanelAction,
  setUpdateVideoListAction,
} from "../actionCreators/manageActionCreator";
import { setErrorHandler } from "./errorActionHandler";

export const getMyDraftsActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setMyDraftsData,
    setTempMyDraftsData,
    setTotalRows,
    onlyCount = false,
  ) =>
  async (dispatch) => {
    await apis.manage
      .getMyDrafts(searchText, pageNumber, pageSize)
      .then((response) => {
        dispatch(getMyDraftsAction(null, response?.data?.TotalRows || 0));
        if (!onlyCount) {
          setMyDraftsData((prevStateData) => [
            ...prevStateData,
            ...response?.data?.Content,
          ]);
          setTempMyDraftsData((prevStateData) => [
            ...prevStateData,
            ...response?.data?.Content,
          ]);
          setTotalRows(response?.data?.TotalRows || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getPublishedByMeActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setPublishedByMeData,
    setTempPublishedByMeData,
    setTotalRows,
    onlyCount = false,
  ) =>
  async (dispatch) => {
    await apis.manage
      .getPublishedByMe(searchText, pageNumber, pageSize)
      .then((response) => {
        dispatch(getPublishedByMeAction(null, response?.data?.TotalRows || 0));
        if (!onlyCount) {
          setPublishedByMeData((prevStateData) => [
            ...prevStateData,
            ...response?.data?.Content,
          ]);
          setTempPublishedByMeData((prevStateData) => [
            ...prevStateData,
            ...response?.data?.Content,
          ]);
          setTotalRows(response?.data?.TotalRows || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getPublishedByOthersActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setPublishedByOthersData,
    setTempPublishedByOthersData,
    setTotalRows,
    onlyCount = false,
  ) =>
  async (dispatch) => {
    await apis.manage
      .getPublishedByOthers(searchText, pageNumber, pageSize)
      .then((response) => {
        dispatch(
          getPublishedByOthersAction(null, response?.data?.TotalRows || 0),
        );
        if (!onlyCount) {
          setPublishedByOthersData((prevStateData) => [
            ...prevStateData,
            ...response.data.Content,
          ]);
          setTempPublishedByOthersData((prevStateData) => [
            ...prevStateData,
            ...response.data.Content,
          ]);
          setTotalRows(response?.data?.TotalRows || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getManageTranscriptionActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setManageTranscriptionData,
    setTempManageTranscriptionData,
    setTotalRows,
    onlyCount = false,
  ) =>
  async (dispatch) => {
    await apis.manage
      .getManageTranscription(searchText, pageNumber, pageSize)
      .then((response) => {
        dispatch(
          getManageTranscriptionAction(null, response?.data?.TotalRows || 0),
        );
        if (!onlyCount) {
          setManageTranscriptionData((prevStateData) => [
            ...prevStateData,
            ...response?.data?.Content,
          ]);
          setTempManageTranscriptionData((prevStateData) => [
            ...prevStateData,
            ...response?.data?.Content,
          ]);
          setTotalRows(response?.data?.TotalRows || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getTrainingTypesActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setTrainingTypesData,
    setTempTrainingTypesData,
    setTotalRows,
  ) =>
  async (dispatch) => {
    dispatch(loaders.manage.createShotclasses.getTrainingTypesLoader(true));
    return await apis.manage
      .getTrainingTypes()
      .then((response) => {
        setTrainingTypesData((prevStateData) => [
          ...prevStateData,
          ...response?.data,
        ]);
        setTempTrainingTypesData((prevStateData) => [
          ...prevStateData,
          ...response?.data,
        ]);
        setTotalRows(response?.data?.length);
        return response?.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(
          loaders.manage.createShotclasses.getTrainingTypesLoader(false),
        );
      });
  };

export const addTrainingTypeActionHandler =
  (trainingName, trainingTypeId) => async (dispatch) => {
    dispatch(loaders.manage.createTrainingType.addTrainingLoader(true));
    let data = { TypeId: trainingTypeId, Name: trainingName };
    return await apis.manage
      .addTrainingType(data)
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.manage.createTrainingType.addTrainingLoader(false));
      });
  };
export const isTrainingTypeExistsActionHandler = (trainingName) => async () => {
  return await apis.manage
    .isTrainingTypeExists(trainingName)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteTrainingTypeActionHandler =
  (trainingTypeId) => async (dispatch) => {
    dispatch(loaders.manage.createTrainingType.deleteTrainingLoader(true));
    return await apis.manage
      .deleteTrainingType(trainingTypeId)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.manage.createTrainingType.deleteTrainingLoader(false));
      });
  };

export const transcribeShotclassActionHandler = (shotclassId) => async () => {
  return await apis.manage
    .transcribeShotclass(shotclassId)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getQuizImagesActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setQuizImagesData,
    setTempQuizImagesData,
    setTotalRows,
  ) =>
  async () => {
    await apis.manage
      .getQuizImages("Published", pageNumber, pageSize)
      .then((response) => {
        setQuizImagesData((prevStateData) => [
          ...prevStateData,
          ...response.data.Content,
        ]);
        setTotalRows(response.data.TotalRows);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getExistingQuizImagesActionHandler = (files) => async () => {
  const keys = Object.keys(files);
  const formData = new FormData();
  keys.forEach((key) => {
    formData.append(`file[${key}]`, files[key]);
  });
  const customConfig = {
    headers: {
      "content-type": "multipart/form-data",
      // AuthenticationToken: localStorage.getItem("token"),
      // TenantSlugName: localStorage.getItem("tenantName"),
    },
  };
  return await apis.manage
    .getExistingQuizImages(formData, customConfig)
    .then((response) => {
      if (response.data) {
        let isMediaExists = false;
        response.data.forEach((res) => {
          if (res === null) {
            return;
          } else if (res?.ISMediaExists) {
            isMediaExists = true;
          }
        });
        return isMediaExists;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
export const postMultiQuizImagesActionHandler = (files) => async () => {
  const keys = Object.keys(files);
  const formData = new FormData();
  keys.forEach((key) => {
    formData.append(`file[${key}]`, files[key]);
  });
  const customConfig = {
    headers: {
      "content-type": "multipart/form-data",
      // AuthenticationToken: localStorage.getItem("token"),
      // TenantSlugName: localStorage.getItem("tenantName"),
    },
  };
  return await apis.manage
    .postMultiQuizImages(formData, customConfig)
    .then((response) => {
      if (response.status === 200) {
        return true;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteQuizImagesActionHandler =
  (data, updatedData, setData, setUpdatedData) => async (dispatch) => {
    dispatch(loaders.manage.contentBulkUpload.deleteQuizImagesLoader(true));
    let filteredData = data;
    let filteredUpdatedData = updatedData;
    await Promise.all(
      data.map(async (val) => {
        if (val.checked) {
          await apis.manage
            .deleteQuizImages(encodeURIComponent(val.MediaUri))
            .then((response) => {
              if (response.data) {
                filteredData = filteredData.filter(
                  (row) => row.Mediaid !== val.Mediaid,
                );
                filteredUpdatedData = filteredUpdatedData.filter(
                  (row) => row.Mediaid !== val.Mediaid,
                );
                dispatch(
                  setErrorHandler(
                    errorTypes.SUCCESS,
                    `${val.FileName} Image successfully deleted`,
                  ),
                );
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }),
    )
      .then(() => {
        setData(filteredData);
        setUpdatedData(filteredUpdatedData);
      })
      .then(() => {
        dispatch(
          loaders.manage.contentBulkUpload.deleteQuizImagesLoader(false),
        );
      });
  };
export const deleteShotclassActionHandler =
  (shotclassId) => async (dispatch) => {
    dispatch(loaders.manage.deleteShotclassLoader(true));
    return await apis.manage
      .deleteShotClass(shotclassId)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.manage.deleteShotclassLoader(false));
      });
  };

export const postCSVBulkUploadActionHandler =
  (typeOfCSVFlag, file) => async (dispatch) => {
    const formData = new FormData();
    formData.append("file", file);
    const customConfig = {
      headers: {
        "content-type": "multipart/form-data",
        // AuthenticationToken: localStorage.getItem("token"),
        // TenantSlugName: localStorage.getItem("tenantName"),
      },
    };
    return await apis.manage
      .postCSVBulkUpload(typeOfCSVFlag, formData, customConfig)
      .then(async (response) => {
        if (response.data) {
          const data = {
            BlobUri: response.data,
            fileName: file.name,
            typeofUploadFile: typeOfCSVFlag,
          };
          return await apis.manage
            .postCSVURLBulkUpload(data)
            .then(async (response) => {
              const csvFileName = file.name.split(".")[0];
              const iscustomlogin = localStorage.getItem(
                "SecurityProviderName",
              );
              return await apis.manage
                .getCSVLastUploadDate(csvFileName, iscustomlogin === "custom")
                .then(async (response) => {
                  if (response.status === 200) {
                    dispatch(
                      setErrorHandler(
                        errorTypes.SUCCESS,
                        `Records has been processed. Admin will be informed if any issues found.`,
                      ),
                    );
                    return true;
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getAllVariantLanguagesActionHandler =
  (setData) => async (dispatch) => {
    dispatch(loaders.manage.createShotclasses.getLanguagesLoader(true));
    await apis.manage
      .getAllVariantLanguages()
      .then((response) => {
        setData(response.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.manage.createShotclasses.getLanguagesLoader(false));
      });
  };

export const getUserGroupsActionHandler = () => async (dispatch) => {
  dispatch(loaders.manage.createShotclasses.getUserGroupsLoader(true));
  return await apis.manage
    .getUserGroups()
    .then((response) => {
      return response.data?.UserGroups;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.manage.createShotclasses.getUserGroupsLoader(false));
    });
};

export const getYoutubeVideosActionHandler =
  (searchQuery, setData) => async (dispatch) => {
    dispatch(loaders.manage.createShotclasses.getYoutubeVideosLoader(true));
    await apis.manage
      .getYoutubeVideos(searchQuery)
      .then((response) => {
        setData(response.data);
        dispatch(
          loaders.manage.createShotclasses.getYoutubeVideosLoader(false),
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getOnlineCoursesActionHandler =
  (searchQuery, setData) => async (dispatch) => {
    dispatch(loaders.manage.createShotclasses.getOnlineCoursesLoader(true));
    await apis.manage
      .getOnlineCourses(searchQuery)
      .then((response) => {
        dispatch(
          loaders.manage.createShotclasses.getOnlineCoursesLoader(false),
        );
        setData(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getSlideSharesActionHandler =
  (searchQuery, setData) => async (dispatch) => {
    dispatch(loaders.manage.createShotclasses.getSlidesharesLoader(true));
    await apis.manage
      .getSlideShares(searchQuery)
      .then((response) => {
        dispatch(loaders.manage.createShotclasses.getSlidesharesLoader(false));
        setData(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const isNameExistsActionHandler =
  (searchText, setState) => async (dispatch) => {
    dispatch(
      loaders.manage.createShotclasses.isShotclassNameExistsLoader(true),
    );
    await apis.manage
      .isNameExists(searchText)
      .then((response) => {
        if (response.data) {
          setState(response.data);
        } else {
          setState(null);
        }
        dispatch(
          loaders.manage.createShotclasses.isShotclassNameExistsLoader(false),
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getSearchClassTagsActionHandler =
  (searchText, setState) => async (dispatch) => {
    dispatch(loaders.manage.createShotclasses.getShotClassTagLoader(true));
    await apis.manage
      .getSearchClassTags(searchText)
      .then((response) => {
        let data = response?.data?.map((tag) => {
          return { TagName: tag, TagValue: tag };
        });
        setState(data);
        dispatch(loaders.manage.createShotclasses.getShotClassTagLoader(false));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getClassDetailsByIdActionHandler =
  (shotclassId, status) => async (dispatch) => {
    dispatch(loaders.common.pageLoader(true));
    await apis.manage
      .getClassDetailsById(shotclassId, status)
      .then((response) => {
        if (response?.data) {
          dispatch(getClassDetailsByIdAction(response?.data));
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.common.pageLoader(false));
      });
  };
export const uploadSlideShareActionHandler =
  (shotclassId, duration = "00:00:00", status, fileData) =>
  async () => {
    let data = {
      classId: shotclassId,
      duration: duration,
      status: status,
      videoUrl: fileData.link,
    };
    return await apis.manage
      .uploadSlideShare(data)
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const createShotclassActionHandler =
  (shotclassData, status, shotClassType) => async (dispatch, getState) => {
    let mediaType = shotclassData.details.Content.ContentMediaType;
    let isContent = !!shotclassData.details.Content.ContentValue;
    const isPublishAction = status !== "Saved";
    const shouldMarkProcessing = isPublishAction && mediaType === 1;
    let quizQuestionList = shotclassData.addQuiz.QuestionsList.map(
      (question, index) => {
        return {
          Type: question.ActiveQuestionType,
          Text: question.Question,
          PositiveMark: 1,
          NegativeMark: 0,
          QuestionNo: index + 1,
          ChoiceList:
            question.ActiveQuestionType === 1
              ? question.AnswersList.map((answer, index) => {
                  return {
                    Text: answer?.Answer,
                    IsAnswer: parseInt(question.IsCorrect) === index,
                    ChoiceImageList: answer?.AnswerImage?.MediaUri
                      ? {
                          MediaUri: answer?.AnswerImage?.MediaUri,
                          FileName: answer?.AnswerImage?.FileName,
                          Mediaid: answer?.AnswerImage?.Mediaid,
                          FileType: answer?.AnswerImage?.FileType,
                          FileSizeinKB: answer?.AnswerImage?.FileSizeinKB,
                          Base64: "",
                          ThumbnailUri: answer?.AnswerImage?.ThumbnailUri,
                          LabelValue: "",
                        }
                      : null,
                    ChoiceAudioList: null,
                    ChoiceVideoList: null,
                  };
                })
              : [
                  {
                    Text: "True",
                    IsAnswer: question.IsCorrect === "True",
                    keyText: "TRUE_TEXT",
                  },
                  {
                    Text: "False",
                    IsAnswer: question.IsCorrect === "False",
                    keyText: "FALSE_TEXT",
                  },
                ],
          Explaination: question.Explanation,
          AnswerHint: "",
          QuestionImageList: question?.QuestionImage?.MediaUri
            ? [
                {
                  MediaUri: question?.QuestionImage?.MediaUri,
                  FileName: question?.QuestionImage?.FileName,
                  Mediaid: question?.QuestionImage?.Mediaid,
                  FileType: question?.QuestionImage?.FileType,
                  FileSizeinKB: question?.QuestionImage?.FileSizeinKB,
                  Base64: "",
                  ThumbnailUri: question?.QuestionImage?.ThumbnailUri,
                  LabelValue: "",
                  isSelected: true,
                },
              ]
            : [],
          QuestionVideoList: [],
          Duration: 0,
          ImageIcon: true,
        };
      },
    );
    let surveyQuestionList = shotclassData.addSurvey.QuestionsList.map(
      (question) => {
        return {
          Choices: question.IsFreeFormTextBox
            ? [{ Text: "" }, { Text: "" }, { Text: "" }, { Text: "" }]
            : question.ActiveQuestionType === 1
              ? shotclassData.addSurvey.surveyType === "basic"
                ? question.AnswersList.map((answer) => {
                    return { Text: answer.Answer };
                  })
                : question.AnswersList.map((answer) => {
                    return { Text: answer.Answer, Grade: answer.Score };
                  })
              : question.ActiveQuestionType === 2
                ? [
                    { Text: "True", keyText: "TRUE_TEXT" },
                    { Text: "False", keyText: "FALSE_TEXT" },
                  ]
                : [{ Text: "" }, { Text: "" }, { Text: "" }, { Text: "" }],
          Edit: false,
          ErrorMessages: [],
          Id: 0,
          Index: 0,
          IsFreeFormText: question.IsFreeFormTextBox,
          Mode: 1,
          MultiSelect: question.MultiSelect,
          QuestionType: question.IsFreeFormTextBox
            ? 3
            : question.ActiveQuestionType === 1
              ? question.MultiSelect
                ? 4
                : 1
              : question.ActiveQuestionType === 2
                ? 2
                : 0,
          Text: question.Question,
        };
      },
    );
    let scoreBandConfigs = shotclassData.addSurvey?.scoreBands?.map(
      (scoreband) => {
        return {
          MinScore: scoreband.minScore,
          MaxScore: scoreband.maxScore,
          FeedbackMessage: scoreband.feedbackMessage,
        };
      },
    );
    // const isExternalCourse = !!shotclassData?.details?.isExternalCourse;
    // const isExternalWebinarCourse =
    //   isExternalCourse &&
    //   !!shotclassData?.details?.TrainingType?.some(
    //     (trainingType) =>
    //       (typeof trainingType === "object" &&
    //         trainingType?.Name?.toLowerCase() === "webinar") ||
    //       (typeof trainingType === "string" &&
    //         trainingType?.toLowerCase() === "webinar"),
    //   );
    // const allowCertificateUpload =
    //   !isExternalWebinarCourse &&
    //   !!shotclassData?.publish?.AllowCertificateUpload;
    // const courseType = isExternalCourse ? "External" : "Internal";
    // const completionVerificationMode = isExternalCourse
    //   ? allowCertificateUpload
    //     ? "CertificateUploadAndApproval"
    //     : "SelfAttested"
    //   : undefined;
    let data = {
      ID: 0,
      Name: shotclassData.details.ShotClassName,
      ImageUrl: shotclassData.details.ThumbnailImage.MediaUri,
      Description: shotclassData.details.Summary,
      KeyLearning: shotclassData.details.Description,
      VideoUrl:
        mediaType === 2 || mediaType === 8
          ? shotclassData.details.Content.ContentValue[0].link
          : "",
      VideoDuration:
        mediaType === 2
          ? shotclassData.details.Content.ContentValue[0].Duration
          : "",
      VideoThumbnailUrl: shotclassData.details.ThumbnailImage.MediaUri,
      AssessmentSet: {
        Name: shotclassData.details.ShotClassName,
        Description: "",
        Duration: 1,
        MaxScore: 100,
        MinScore: shotclassData.addQuiz.PassingMarks
          ? parseInt(shotclassData.addQuiz.PassingMarks)
          : "",
        AllowReattempt: false,
        QuestionList:
          shotclassData.addQuiz.TotalQuestionCount > 0 ? quizQuestionList : [],
        Locale: shotclassData.details.Language,
        ParentId: 0,
        ID: 0,
      },
      Credits: "",
      Tags: shotclassData.details.TagsList.map((tag) => tag.TagName).join(","),
      Status: shouldMarkProcessing
        ? 5
        : status
          ? status
          : isContent
            ? // mediaType === 2 || mediaType === 8
              //   ? "Published"
              // :
              "Saved"
            : "Published",
      StatusText: shouldMarkProcessing
        ? "Processing"
        : status
          ? status
          : isContent
            ? "Saved"
            : "Published",
      VideoUploadStatus: "VideoNotAvailable",
      Logo: "https://mlearn.blob.core.windows.net/shotclass/img/hp-logo.gif",
      CategoryID: "",
      TrainingTypeId: shotclassData.details.TrainingType?.map(
        (training) => training.TypeId,
      ),
      Type: "ShotClass",
      ParentId: 0,
      Mediatype: mediaType,
      MediaSource: "",
      MoocCourseSubType: 0,
      Locale: shotclassData.details.Language,
      IsMediaDownloadable: shotclassData.publish.OfflineShotclass,
      IsClassDownloadable: shotclassData.publish.OfflineShotclass,
      IsRestrictedClass: shotclassData.publish.HasRestricted,
      IsVideoMandatory: shotclassData.publish.IsVideoMandatory,
      IsRandomQuestionAllowed: shotclassData.publish.QuestionJumbling,
      ShowCorrectAnswer: shotclassData.publish.ShowCorrectAnswers,
      LearnerChangeAnswerOptions: shotclassData.publish.CanChangeAnswers,
      // ...(!isExternalWebinarCourse && {
      //   AllowCertificateUpload: !!shotclassData.publish.AllowCertificateUpload,
      // }),
      // CourseType: courseType,
      // ...(completionVerificationMode && {
      //   CompletionVerificationMode: completionVerificationMode,
      // }),
      ShotclassTargetGroupMapping: shotclassData.publish.HasRestricted
        ? shotclassData.publish.ShotclassTargetGroupMapping?.map((tag) => {
            return { TargetGroupId: 1, TargetGroupMemberId: tag.UserGroupId };
          })
        : [],
      Survey: {
        SurveyId: "",
        Locale: shotclassData.details.Language,
        ShotClassId: 20,
        IsMandatory: shotclassData.publish.IsSurveyMandatory,
        Type: shotclassData.addSurvey.surveyType === "scored" ? 1 : 0,
        // ✅ Add ScoreBandConfigs only for scored surveys
        ...(shotclassData.addSurvey.surveyType === "scored" && {
          IsTrackingEnabled: shotclassData.publish.IsTrackingEnabled,
          scoreBandConfigs: scoreBandConfigs,
        }),
        Questions:
          shotclassData.addSurvey.TotalQuestionCount > 0
            ? surveyQuestionList
            : [],
      },
      ShotClassType: shotClassType
        ? shotClassType
        : shotclassData.publish.LearningContentOnly,
      // ✅ Add completion configuration for create operation (dynamic values only)
      ...(shotclassData.publish.isCustomCompletionEnabled &&
        shotclassData.publish.completionConfiguration && {
          isCustomCompletionEnabled:
            shotclassData.publish.isCustomCompletionEnabled,
          completionConfiguration:
            shotclassData.publish.completionConfiguration,
        }),
    };
    console.log("data", data);
    return await apis.manage
      .createShotclass(data)
      .then((response) => {
        if (response?.data) {
          const classId = response?.data.split(":")[1].trim();
          const shotclassName = shotclassData?.details?.ShotClassName;
          const fileData = shotclassData.details.Content.ContentValue[0];
          const fileName = fileData?.name;
          const fileSize = fileData?.size;
          const fileExtension =
            shotclassData.details.Content.ContentMediaExtension;
          if (
            shotclassData.details.TrainingType?.[0]?.Name?.toLowerCase() ===
            "webinar"
          ) {
            const calanderFileData = shotclassData.details.CalendarUrl[0];
            const calanderFileExtension = ".ics";
            dispatch(
              uploadCalanderFileActionHandler(
                classId,
                calanderFileExtension,
                calanderFileData,
              ),
            );
          }
          if (
            (fileData && fileExtension) ||
            mediaType === 5 ||
            mediaType === 2 ||
            mediaType === 8
          ) {
            if (mediaType === 1) {
              const blockLength = 1048576;
              const blockCount = Math.ceil(fileSize / blockLength);

              return dispatch(getStoredMediaInfoActionHandler(classId))
                .then(() => {
                  return dispatch(
                    setMetaDataForVideoActionHandler(
                      blockCount,
                      fileName,
                      fileSize,
                      shotclassName,
                    ),
                  );
                })
                .then((data) => {
                  let uploadChunkObject = {
                    videoGuid: data?.VideoGuid,
                    // classId: classId,
                    classId: response?.data,
                    isVariant: false,
                    status: status ? status : "Published",
                    fileName: fileName,
                    url: "uploading",
                    fileSize: fileSize,
                    blockLength: blockLength,
                    blockCount: blockCount,
                    uploadStatusMessage: "xsadsd",
                    isUploadCompleted: false,
                    isShotClassSourcingFromLearner: false,
                    file: fileData,
                  };
                  const videoItem = {
                    id: classId,
                    name: fileName,
                    totalChunk: blockCount,
                    completedChunk: 0,
                    className: shotclassName,
                    currentStatus: videoUploadStatus.PENDING,
                    chunkObject: uploadChunkObject,
                  };
                  const videoList = getState()?.manageReducer?.videoUploadList;
                  const updatedVideoList = [videoItem, ...videoList];
                  dispatch(setUpdateVideoListAction(updatedVideoList));

                  dispatch(
                    uploadVideoChunkActionHandler(uploadChunkObject, classId),
                  );
                  return "video";
                });
            } else if (mediaType === 3) {
              return dispatch(
                uploadPptShotClassActionHandler(
                  classId,
                  fileExtension,
                  false,
                  status ? status : "Published",
                  fileData,
                ),
              );
            } else if (mediaType === 5 || mediaType === 2 || mediaType === 8) {
              return dispatch(
                uploadSlideShareActionHandler(
                  classId,
                  mediaType === 2 ? fileData?.Duration : "00:00:00",
                  status ? status : "Published",
                  fileData,
                ),
              );
            } else if (mediaType === 7) {
              return dispatch(
                uploadPdfShotClassActionHandler(
                  classId,
                  fileExtension,
                  false,
                  status ? status : "Published",
                  fileData,
                ),
              );
            } else if (mediaType === 9 || mediaType === 11) {
              let isHTML = mediaType === 11 ? true : false;
              return dispatch(
                uploadScormOrHtmlShotClassActionHandler(
                  isHTML,
                  classId,
                  fileExtension,
                  fileName,
                  false,
                  status ? status : "Published",
                  fileData,
                ),
              );
            }
          } else {
            return true;
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const updateShotclassActionHandler =
  (shotclassData, status, shotClassType) => async (dispatch, getState) => {
    const normalizeVideoReference = (value) => {
      if (!value) return "";
      const candidate =
        typeof value === "string"
          ? value
          : Array.isArray(value)
            ? value?.[0]?.link || value?.[0]?.MediaUri || ""
            : "";
      if (!candidate || typeof candidate !== "string") return "";
      const pathWithoutQuery = candidate.split("?")[0] || "";
      return pathWithoutQuery.split("/").pop() || pathWithoutQuery;
    };

    let mediaType = shotclassData.details.Content.ContentMediaType;
    let isContent = !!shotclassData.details.Content.ContentValue;
    const isPublishAction = status !== "Saved";
    const currentVideoStatus = shotclassData.Other?.VideoUploadStatus;
    const currentVideoStatusText = (
      shotclassData.Other?.VideoUploadStatusText || ""
    )
      .toString()
      .trim()
      .toLowerCase();
    const isCurrentVideoSaved =
      Number(currentVideoStatus) === 4 ||
      String(currentVideoStatus).toLowerCase() === "saved" ||
      currentVideoStatusText === "saved";
    const isFromMyDrafts =
      localStorage.getItem("shotclassTypeFrom") === "myDrafts";
    const isNewContentSelected =
      shotclassData.Other?.VideoUrl !==
      shotclassData.details.Content.ContentValue;
    const sourceVideoReference = normalizeVideoReference(
      shotclassData.Other?.VideoUrl,
    );
    const targetVideoReference = normalizeVideoReference(
      shotclassData.details.Content.ContentValue,
    );
    const isContentSame =
      mediaType === 1
        ? sourceVideoReference && targetVideoReference
          ? sourceVideoReference === targetVideoReference
          : shotclassData.Other?.VideoUrl ===
            shotclassData.details.Content.ContentValue
        : shotclassData.Other?.VideoUrl ===
          shotclassData.details.Content.ContentValue;
    const isContentChanged = !isContentSame;
    const sourceStatus = shotclassData.Other?.Status;
    const sourceStatusText =
      sourceStatus === 0 || sourceStatus === "0"
        ? "Saved"
        : sourceStatus === 1 || sourceStatus === "1"
          ? "Published"
          : shotclassData.Other?.StatusText || "";
    const targetStatus = status ? status : "Published";
    const shouldQueueExistingVideo =
      mediaType === 1 &&
      isFromMyDrafts &&
      isContentSame &&
      sourceStatusText === "Saved" &&
      targetStatus === "Published";
    const shouldSetVideoNotAvailable =
      mediaType === 1 && (isContentChanged || shouldQueueExistingVideo);
    const shouldMarkProcessing =
      isPublishAction &&
      mediaType === 1 &&
      (isCurrentVideoSaved || isNewContentSelected);
    let quizQuestionList = shotclassData.addQuiz.QuestionsList.map(
      (question, index) => {
        let {
          Question,
          QuestionImage,
          Explanation,
          ActiveQuestionType,
          IsCorrect,
          AnswersList,
          ...restQuestion
        } = question;
        return {
          ...restQuestion,
          // AssessmentName: null,
          // ID: shotclassData.ID,
          Type: ActiveQuestionType,
          Text: Question,
          QuestionNo: index + 1,
          // PositiveMark: 1,
          // NegativeMark: 0,
          ChoiceList:
            ActiveQuestionType === 1
              ? AnswersList?.map((answer, index) => {
                  let { Answer, AnswerImage, ...restAnswer } = answer;

                  return {
                    ...restAnswer,
                    // ID: shotclassData.ID,
                    Text: Answer,
                    IsAnswer: parseInt(IsCorrect) === index,
                    // ImageForWorng: answer?.ImageForWorng || "",
                    // ImageForCorrect: answer?.ImageForCorrect || "",
                    // Isselected: answer?.Isselected || "",
                    // IsselectedByUserInResonse:
                    //   answer?.IsselectedByUserInResonse || false,
                    // IsDeleted: answer?.IsDeleted || false,
                    // QuestionId: answer?.QuestionId,
                    // BaseChoiceId: answer?.BaseChoiceId,
                    // VaraintChoiceId: answer?.VaraintChoiceId,
                    ChoiceImageList: AnswerImage?.MediaUri
                      ? {
                          MediaUri: AnswerImage?.MediaUri,
                          FileName: AnswerImage?.FileName,
                          Mediaid: AnswerImage?.Mediaid,
                          FileType: AnswerImage?.FileType,
                          FileSizeinKB: AnswerImage?.FileSizeinKB,
                          Base64: "",
                          ThumbnailUri: AnswerImage?.ThumbnailUri,
                          LabelValue: "",
                        }
                      : null,
                    // ChoiceAudioList: null,
                    // ChoiceVideoList: null,
                  };
                })
              : question?.ChoiceList?.length > 1
                ? AnswersList.map((answer) => {
                    let { Answer, AnswerImage, ...restAnswer } = answer;
                    const isChanged =
                      AnswersList.find((item) => item?.IsAnswer)?.Text?.toLowerCase() !==
                      IsCorrect?.toLowerCase();
                    if (answer?.Text?.toLowerCase() === "true") {
                      return {
                        ...restAnswer,
                        Text: answer?.Text,
                        IsAnswer: isChanged ? IsCorrect === "True" : answer?.IsAnswer,
                        keyText: "TRUE_TEXT",
                      };
                    } else {
                      return {
                        ...restAnswer,
                        Text: answer?.Text,
                        IsAnswer: isChanged ? IsCorrect === "False" : answer?.IsAnswer,
                        keyText: "FALSE_TEXT",
                      };
                    }
                  })
                : [
                    {
                      Text: "True",
                      IsAnswer: IsCorrect === "True",
                      keyText: "TRUE_TEXT",
                    },
                    {
                      Text: "False",
                      IsAnswer: IsCorrect === "False",
                      keyText: "FALSE_TEXT",
                    },
                  ],
          // IsDeleted: question?.IsDeleted,
          Explaination: Explanation,
          // AnswerHint: question?.AnswerHint,
          QuestionImageList: QuestionImage?.MediaUri
            ? [
                {
                  MediaUri: QuestionImage?.MediaUri,
                  FileName: QuestionImage?.FileName,
                  Mediaid: QuestionImage?.Mediaid,
                  FileType: QuestionImage?.FileType,
                  FileSizeinKB: QuestionImage?.FileSizeinKB,
                  Base64: "",
                  ThumbnailUri: QuestionImage?.ThumbnailUri,
                  LabelValue: "",
                  isSelected: true,
                },
              ]
            : [],
          // QuestionAudioList: question?.QuestionAudioList,
          // QuestionVideoList: question?.QuestionVideoList,
          // Duration: question?.Duration,
          // BaseQuestionId: question?.BaseQuestionId,
          // VariantQuestionId: question?.VariantQuestionId,
          // QuizTemplateId:question?.QuizTemplateId,
        };
      },
    );
    let surveyQuestionList = shotclassData.addSurvey.QuestionsList.map(
      (question) => {
        let {
          Question,
          ActiveQuestionType,
          AnswersList,
          MultiSelect,
          IsFreeFormTextBox,
          ...restQuestion
        } = question;
        return {
          ...restQuestion,
          Choices: IsFreeFormTextBox
            ? [{ Text: "" }, { Text: "" }, { Text: "" }, { Text: "" }]
            : ActiveQuestionType === 1
              ? shotclassData.addSurvey.surveyType === "basic"
                ? AnswersList?.map((answer) => {
                    let { Answer, Grade, Score, ...restAnswer } = answer;
                    return { ...restAnswer, Text: Answer };
                  })
                : AnswersList?.map((answer) => {
                    let { Answer, Grade, Score, ...restAnswer } = answer;
                    return { ...restAnswer, Text: Answer, Grade: answer.Score };
                  })
              : ActiveQuestionType === 2
                ? question.Choices?.length > 1
                  ? AnswersList?.map((answer) => {
                      let { Answer, ...restAnswer } = answer;
                      if (answer?.Text === "True") {
                        return {
                          ...restAnswer,
                          Text: "True",
                          keyText: "TRUE_TEXT",
                        };
                      } else {
                        return {
                          ...restAnswer,
                          Text: "False",
                          keyText: "FALSE_TEXT",
                        };
                      }
                    })
                  : [
                      { Text: "True", keyText: "TRUE_TEXT" },
                      { Text: "False", keyText: "FALSE_TEXT" },
                    ]
                : [{ Text: "" }, { Text: "" }, { Text: "" }, { Text: "" }],
          Edit: false,
          IsDeleted: false,
          // ErrorMessages: [],
          Id:
            shotclassData?.Other?.Survey?.UserSurveyCompletionCount > 0
              ? question?.Id
              : 0,
          // Index: 0,
          IsFreeFormText: IsFreeFormTextBox,
          NegativeMark: 0,
          PositiveMark: 1,
          // Mode: 1,
          MultiSelect: MultiSelect,
          QuestionType: IsFreeFormTextBox
            ? 3
            : ActiveQuestionType === 1
              ? MultiSelect
                ? 4
                : 1
              : ActiveQuestionType === 2
                ? 2
                : 0,
          Text: Question,
        };
      },
    );
    let scoreBandConfigs = shotclassData.addSurvey?.scoreBands?.map(
      (scoreband) => {
        return {
          MinScore: scoreband.minScore,
          MaxScore: scoreband.maxScore,
          FeedbackMessage: scoreband.feedbackMessage,
        };
      },
    );
    // const isExternalCourse = !!shotclassData?.details?.isExternalCourse;
    // const isExternalWebinarCourse =
    //   isExternalCourse &&
    //   !!shotclassData?.details?.TrainingType?.some(
    //     (trainingType) =>
    //       (typeof trainingType === "object" &&
    //         trainingType?.Name?.toLowerCase() === "webinar") ||
    //       (typeof trainingType === "string" &&
    //         trainingType?.toLowerCase() === "webinar"),
    //   );
    // const allowCertificateUpload =
    //   !isExternalWebinarCourse &&
    //   !!shotclassData?.publish?.AllowCertificateUpload;
    // const courseType = isExternalCourse ? "External" : "Internal";
    // const completionVerificationMode = isExternalCourse
    //   ? allowCertificateUpload
    //     ? "CertificateUploadAndApproval"
    //     : "SelfAttested"
    //   : undefined;
    // ✅ Exclude completion configuration and course completion duration from Other to prevent duplicates
    const {
      IsCustomCompletionEnabled,
      CompletionConfiguration,
      CourseCompletionDuration,
      coursecompletionduration,
      ...otherData
    } = shotclassData.Other;
    let data = {
      ...otherData,
      // ID: shotclassData.ID,
      ParentId: `${shotclassData.ShotclassId}`,
      // .toString(),
      Name: shotclassData.details.ShotClassName,
      ImageUrl:
        typeof shotclassData.details.ThumbnailImage === "string"
          ? shotclassData.details.ThumbnailImage
          : shotclassData.details.ThumbnailImage.MediaUri,
      // ImageFileSizeinKB: null,
      Description: shotclassData.details.Summary,
      KeyLearning: shotclassData.details.Description,
      VideoUrl:
        // mediaType === 2 || mediaType === 8
        //   ?
        shotclassData.Other?.VideoUrl !==
        shotclassData.details.Content.ContentValue
          ? mediaType === 2 || mediaType === 8
            ? shotclassData.details.Content.ContentValue[0]?.link
            : ""
          : shotclassData.details.Content.ContentValue,
      // ?
      // shotclassData.details.Content.ContentMediaExtension === ""
      // shotclassData.details.Content?.ContentValue ===
      // shotclassData?.Other?.VideoUrl
      // : shotclassData.details.Content.ContentValue[0]?.link,
      // : ""
      VideoDuration:
        mediaType === 1
          ? shotclassData.Other?.VideoUrl ===
            shotclassData.details.Content.ContentValue
            ? shotclassData.Other?.VideoDuration
            : "00:00:00"
          : mediaType === 2
            ? shotclassData.Other?.VideoUrl !==
              shotclassData.details.Content.ContentValue
              ? shotclassData.details.Content.ContentValue[0].Duration
              : shotclassData.Other?.VideoDuration
            : null,
      VideoThumbnailUrl:
        typeof shotclassData.details.ThumbnailImage === "string"
          ? shotclassData.details.ThumbnailImage
          : shotclassData.details.ThumbnailImage.MediaUri,
      AssessmentSet: {
        ...shotclassData.Other.AssessmentSet,
        ParentId: shotclassData.Other.AssessmentSet.ID,
        // Name: shotclassData.details.ShotClassName,
        // Description: "",
        // Duration: 1,
        // MaxScore: 100,
        MinScore:
          shotclassData.addQuiz.TotalQuestionCount > 0
            ? shotclassData.addQuiz.PassingMarks
              ? parseInt(shotclassData.addQuiz.PassingMarks)
              : ""
            : 0,
        // AllowReattempt: false,
        QuestionList:
          shotclassData.addQuiz.TotalQuestionCount > 0 ? quizQuestionList : [],
        // Locale: shotclassData.details.Language,
        // ParentId: 0,
        // ID: shotclassData.ID,
      },
      // Credits: "",
      Tags: shotclassData.details.TagsList.map((tag) => tag.TagName).join(","),
      Status: shouldMarkProcessing
        ? 5
        : status
          ? status
          : // (isContent && shotclassData.details.Content.ContentMediaExtension) ||
            shotclassData.Other?.VideoUrl !==
              shotclassData.details.Content.ContentValue
            ? // mediaType === 2 || mediaType === 8
              //   ? "Published"
              //   :
              "Saved"
            : "Published",
      StatusText: shouldMarkProcessing
        ? "Processing"
        : status
          ? status
          : shotclassData.Other?.VideoUrl !==
              shotclassData.details.Content.ContentValue
            ? "Saved"
            : "Published",
      VideoUploadStatus: shouldSetVideoNotAvailable
        ? 0
        : shotclassData.Other?.VideoUploadStatus,
      VideoUploadStatusText: shouldSetVideoNotAvailable
        ? "VideoNotAvailable"
        : shotclassData.Other?.VideoUploadStatusText,
      // Logo: "https://mlearn.blob.core.windows.net/shotclass/img/hp-logo.gif",
      // CategoryID: "",
      TrainingTypeId: shotclassData.details.TrainingType?.map(
        (training) => training.TypeId,
      ),
      // Type: "ShotClass",
      // ParentId: 0,
      Mediatype: mediaType,
      ShotclassVersion:
        shotclassData.Other?.ShotclassVersion === "1"
          ? "2"
          : shotclassData.Other?.ShotclassVersion || undefined,
      // MediaSource: "",
      // MoocCourseSubType: 0,
      Locale: shotclassData.details.Language,
      IsMediaDownloadable: shotclassData.publish.OfflineShotclass,
      IsClassDownloadable: shotclassData.publish.OfflineShotclass,
      IsRestrictedClass: shotclassData.publish.HasRestricted,
      IsVideoMandatory: shotclassData.publish.IsVideoMandatory,
      IsRandomQuestionAllowed: shotclassData.publish.QuestionJumbling,
      ShowCorrectAnswer: shotclassData.publish.ShowCorrectAnswers,
      LearnerChangeAnswerOptions: shotclassData.publish.CanChangeAnswers,
      // ...(!isExternalWebinarCourse && {
      //   AllowCertificateUpload: !!shotclassData.publish.AllowCertificateUpload,
      // }),
      // CourseType: courseType,
      // ...(completionVerificationMode && {
      //   CompletionVerificationMode: completionVerificationMode,
      // }),
      ShotclassTargetGroupMapping: shotclassData.publish.HasRestricted
        ? shotclassData.publish.ShotclassTargetGroupMapping?.map((tag) => {
            return { TargetGroupId: 1, TargetGroupMemberId: tag.UserGroupId };
          })
        : [],
      Survey:
        shotclassData.addSurvey.TotalQuestionCount > 0
          ? shotclassData.Other?.Survey
            ? (() => {
                // ✅ Destructure and exclude unwanted properties
                const { IsTrackingEnabled, ...cleanSurvey } =
                  shotclassData.Other.Survey;
                return {
                  ...cleanSurvey,
                  IsMandatory: shotclassData.publish.IsSurveyMandatory,
                  Questions:
                    shotclassData.addSurvey.TotalQuestionCount > 0
                      ? surveyQuestionList
                      : [],
                  Type: shotclassData.addSurvey.surveyType === "basic" ? 0 : 1,
                  // ✅ Add ScoreBandConfigs only for scored surveys
                  ...(shotclassData.addSurvey.surveyType === "scored" && {
                    scoreBandConfigs: scoreBandConfigs,
                    IsTrackingEnabled: shotclassData.publish.IsTrackingEnabled,
                  }),
                };
              })()
            : {
                SurveyId: "",
                Locale: shotclassData.details.Language,
                ShotClassId: shotclassData?.ShotclassId,
                IsMandatory: shotclassData.publish.IsSurveyMandatory,
                Questions:
                  shotclassData.addSurvey.TotalQuestionCount > 0
                    ? surveyQuestionList
                    : [],
                Type: shotclassData.addSurvey.surveyType === "basic" ? 0 : 1,
                // ✅ Add ScoreBandConfigs only for scored surveys
                ...(shotclassData.addSurvey.surveyType === "scored" && {
                  scoreBandConfigs: scoreBandConfigs,
                  IsTrackingEnabled: shotclassData.publish.IsTrackingEnabled,
                }),
              }
          : null,
      ShotClassType: shotClassType
        ? shotClassType
        : shotclassData.publish.LearningContentOnly,
      // ✅ Add completion configuration for update operation (dynamic values only)
      ...(shotclassData.publish.isCustomCompletionEnabled &&
        shotclassData.publish.completionConfiguration && {
          isCustomCompletionEnabled:
            shotclassData.publish.isCustomCompletionEnabled,
          completionConfiguration:
            shotclassData.publish.completionConfiguration,
        }),
      CalendarUrl: Array.isArray(shotclassData?.details?.CalendarUrl)
        ? null
        : shotclassData?.details?.CalendarUrl,
    };
    debugger;
    return await apis.manage
      .updateShotclass(data)
      .then((response) => {
        if (response?.data) {
          const classId = response?.data.split(":")[1].trim();
          const shotclassName = shotclassData?.details?.ShotClassName;
          const fileData = shotclassData.details.Content.ContentValue[0];
          const fileName = fileData?.name;
          const fileSize = fileData?.size;
          const fileExtension =
            shotclassData.details.Content.ContentMediaExtension;
          if (
            shotclassData.details.TrainingType?.[0]?.Name?.toLowerCase() ===
              "webinar" &&
            fileData &&
            //Checking if the calander file is modified or not
            shotclassData.details.CalendarUrl &&
            Array.isArray(shotclassData.details.CalendarUrl) &&
            shotclassData.details.CalendarUrl.length > 0 &&
            shotclassData.details.CalendarUrl[0]
          ) {
            const calanderFileData = shotclassData.details.CalendarUrl[0];
            const calanderFileExtension = ".ics";
            dispatch(
              uploadCalanderFileActionHandler(
                classId,
                calanderFileExtension,
                calanderFileData,
              ),
            );
          }
          if (
            isContentChanged ||
            shouldQueueExistingVideo
            // (fileData && fileExtension) ||
            // mediaType === 5 ||
            // mediaType === 2 ||
            // mediaType === 8
          ) {
            if (mediaType === 1) {
              if (shouldQueueExistingVideo) {
                const shotClassID = shotclassData?.ShotclassId;
                return dispatch(
                  getStoredMediaInfoActionHandler(shotClassID),
                ).then((classData) => {
                  if (!classData) {
                    return true;
                  }
                  const blobName =
                    classData?.BlobName || shotclassData?.Other?.VideoUrl || "";
                  const blobFileSize = classData?.FileSize;
                  return dispatch(
                    addToQueueVideoActionHandler(
                      blobName,
                      parseInt(classId, 10),
                      targetStatus,
                      blobFileSize,
                    ),
                  );
                });
              } else if (isContentChanged) {
                const blockLength = 1048576;
                const blockCount = Math.ceil(fileSize / blockLength);

                return dispatch(
                  setMetaDataForVideoActionHandler(
                    blockCount,
                    fileName,
                    fileSize,
                    shotclassName,
                  ),
                ).then((data) => {
                  let uploadChunkObject = {
                    videoGuid: data?.VideoGuid,
                    // classId: classId,
                    classId: response?.data,
                    isVariant: false,
                    status: targetStatus,
                    fileName: fileName,
                    url: "uploading",
                    fileSize: fileSize,
                    blockLength: blockLength,
                    blockCount: blockCount,
                    uploadStatusMessage: "xsadsd",
                    isUploadCompleted: false,
                    isShotClassSourcingFromLearner: false,
                    file: fileData,
                  };
                  const videoItem = {
                    id: classId,
                    name: fileName,
                    totalChunk: blockCount,
                    completedChunk: 0,
                    className: shotclassName,
                    currentStatus: videoUploadStatus.PENDING,
                    chunkObject: uploadChunkObject,
                  };
                  const videoList = getState()?.manageReducer?.videoUploadList;
                  const updatedVideoList = [videoItem, ...videoList];
                  dispatch(setUpdateVideoListAction(updatedVideoList));

                  dispatch(
                    uploadVideoChunkActionHandler(uploadChunkObject, classId),
                  );
                  return "video";
                });
              } else {
                return true;
              }
            } else if (mediaType === 3) {
              return dispatch(
                uploadPptShotClassActionHandler(
                  classId,
                  fileExtension,
                  false,
                  status ? status : "Published",
                  fileData,
                ),
              );
            } else if (mediaType === 5 || mediaType === 2 || mediaType === 8) {
              return dispatch(
                uploadSlideShareActionHandler(
                  classId,
                  mediaType === 2 ? fileData?.Duration : "00:00:00",
                  status ? status : "Published",
                  fileData,
                ),
              );
            } else if (mediaType === 7) {
              return dispatch(
                uploadPdfShotClassActionHandler(
                  classId,
                  fileExtension,
                  false,
                  status ? status : "Published",
                  fileData,
                ),
              );
            } else if (mediaType === 9 || mediaType === 11) {
              let isHTML = mediaType === 11 ? true : false;
              return dispatch(
                uploadScormOrHtmlShotClassActionHandler(
                  isHTML,
                  classId,
                  fileExtension,
                  fileName,
                  false,
                  status ? status : "Published",
                  fileData,
                ),
              );
            }
          } else {
            return true;
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const copyShotclassActionHandler =
  (shotclassData, status, shotClassType) => async (dispatch, getState) => {
    let mediaType = shotclassData.details.Content.ContentMediaType;
    let isContent = !!shotclassData.details.Content.ContentValue;
    const isPublishAction = status !== "Saved";
    const currentVideoStatus = shotclassData.Other?.VideoUploadStatus;
    const currentVideoStatusText = (
      shotclassData.Other?.VideoUploadStatusText || ""
    )
      .toString()
      .trim()
      .toLowerCase();
    const isCurrentVideoSaved =
      Number(currentVideoStatus) === 4 ||
      String(currentVideoStatus).toLowerCase() === "saved" ||
      currentVideoStatusText === "saved";
    const isFromMyDrafts =
      localStorage.getItem("shotclassTypeFrom") === "myDrafts";
    const isNewContentSelected =
      shotclassData.Other?.VideoUrl !==
      shotclassData.details.Content.ContentValue;
    const isContentSame =
      shotclassData.Other?.VideoUrl ===
      shotclassData.details.Content.ContentValue;
    const isContentChanged = !isContentSame;
    const effectiveStatus = status
      ? status
      : shotclassData.Other?.VideoUrl !==
          shotclassData.details.Content.ContentValue
        ? "Saved"
        : "Published";
    const shouldQueueExistingVideo =
      mediaType === 1 && isFromMyDrafts && isContentSame && effectiveStatus;
    const shouldSetVideoNotAvailable =
      mediaType === 1 && (isContentChanged || shouldQueueExistingVideo);
    const shouldMarkProcessing =
      isPublishAction &&
      mediaType === 1 &&
      (isCurrentVideoSaved || isNewContentSelected);
    let quizQuestionList = shotclassData.addQuiz.QuestionsList.map(
      (question, index) => {
        let {
          Question,
          QuestionImage,
          Explanation,
          ActiveQuestionType,
          IsCorrect,
          AnswersList,
          ...restQuestion
        } = question;
        return {
          ...restQuestion,
          // AssessmentName: null,
          // ID: shotclassData.ID,
          Type: ActiveQuestionType,
          Text: Question,
          QuestionNo: index + 1,
          // PositiveMark: 1,
          // NegativeMark: 0,
          ChoiceList:
            ActiveQuestionType === 1
              ? AnswersList?.map((answer, index) => {
                  let { Answer, AnswerImage, ...restAnswer } = answer;

                  return {
                    ...restAnswer,
                    // ID: shotclassData.ID,
                    Text: Answer,
                    IsAnswer: parseInt(IsCorrect) === index,
                    // ImageForWorng: answer?.ImageForWorng || "",
                    // ImageForCorrect: answer?.ImageForCorrect || "",
                    // Isselected: answer?.Isselected || "",
                    // IsselectedByUserInResonse:
                    //   answer?.IsselectedByUserInResonse || false,
                    // IsDeleted: answer?.IsDeleted || false,
                    // QuestionId: answer?.QuestionId,
                    // BaseChoiceId: answer?.BaseChoiceId,
                    // VaraintChoiceId: answer?.VaraintChoiceId,
                    ChoiceImageList: AnswerImage?.MediaUri
                      ? {
                          MediaUri: AnswerImage?.MediaUri,
                          FileName: AnswerImage?.FileName,
                          Mediaid: AnswerImage?.Mediaid,
                          FileType: AnswerImage?.FileType,
                          FileSizeinKB: AnswerImage?.FileSizeinKB,
                          Base64: "",
                          ThumbnailUri: AnswerImage?.ThumbnailUri,
                          LabelValue: "",
                        }
                      : null,
                    // ChoiceAudioList: null,
                    // ChoiceVideoList: null,
                  };
                })
              : question?.ChoiceList?.length > 1
                ? AnswersList.map((answer) => {
                    let { Answer, AnswerImage, ...restAnswer } = answer;
                    const isChanged =
                      AnswersList.find((item) => item?.IsAnswer)?.Text?.toLowerCase() !==
                      IsCorrect?.toLowerCase();
                    if (answer?.Text?.toLowerCase() === "true") {
                      return {
                        ...restAnswer,
                        Text: answer?.Text,
                        IsAnswer: isChanged ? IsCorrect === "True" : answer?.IsAnswer,
                        keyText: "TRUE_TEXT",
                      };
                    } else {
                      return {
                        ...restAnswer,
                        Text: answer?.Text,
                        IsAnswer: isChanged ? IsCorrect === "False" : answer?.IsAnswer,
                        keyText: "FALSE_TEXT",
                      };
                    }
                  })
                : [
                    {
                      Text: "True",
                      IsAnswer: IsCorrect === "True",
                      keyText: "TRUE_TEXT",
                    },
                    {
                      Text: "False",
                      IsAnswer: IsCorrect === "False",
                      keyText: "FALSE_TEXT",
                    },
                  ],
          // IsDeleted: question?.IsDeleted,
          Explaination: Explanation,
          // AnswerHint: question?.AnswerHint,
          QuestionImageList: QuestionImage?.MediaUri
            ? [
                {
                  MediaUri: QuestionImage?.MediaUri,
                  FileName: QuestionImage?.FileName,
                  Mediaid: QuestionImage?.Mediaid,
                  FileType: QuestionImage?.FileType,
                  FileSizeinKB: QuestionImage?.FileSizeinKB,
                  Base64: "",
                  ThumbnailUri: QuestionImage?.ThumbnailUri,
                  LabelValue: "",
                  isSelected: true,
                },
              ]
            : [],
          // QuestionAudioList: question?.QuestionAudioList,
          // QuestionVideoList: question?.QuestionVideoList,
          // Duration: question?.Duration,
          // BaseQuestionId: question?.BaseQuestionId,
          // VariantQuestionId: question?.VariantQuestionId,
          // QuizTemplateId:question?.QuizTemplateId,
        };
      },
    );
    let surveyQuestionList = shotclassData.addSurvey.QuestionsList.map(
      (question) => {
        let {
          Question,
          ActiveQuestionType,
          AnswersList,
          MultiSelect,
          IsFreeFormTextBox,
          ...restQuestion
        } = question;
        return {
          ...restQuestion,
          Choices: IsFreeFormTextBox
            ? [{ Text: "" }, { Text: "" }, { Text: "" }, { Text: "" }]
            : ActiveQuestionType === 1
              ? shotclassData.addSurvey.surveyType === "basic"
                ? AnswersList?.map((answer) => {
                    let { Answer, ...restAnswer } = answer;
                    return { ...restAnswer, Text: Answer };
                  })
                : AnswersList?.map((answer) => {
                    let { Answer, ...restAnswer } = answer;
                    return { ...restAnswer, Text: Answer, Grade: answer.Score };
                  })
              : ActiveQuestionType === 2
                ? question.Choices?.length > 1
                  ? AnswersList?.map((answer) => {
                      let { Answer, ...restAnswer } = answer;
                      if (answer?.Text === "True") {
                        return {
                          ...restAnswer,
                          Text: "True",
                          keyText: "TRUE_TEXT",
                        };
                      } else {
                        return {
                          ...restAnswer,
                          Text: "False",
                          keyText: "FALSE_TEXT",
                        };
                      }
                    })
                  : [
                      { Text: "True", keyText: "TRUE_TEXT" },
                      { Text: "False", keyText: "FALSE_TEXT" },
                    ]
                : [{ Text: "" }, { Text: "" }, { Text: "" }, { Text: "" }],
          Edit: false,
          IsDeleted: false,
          // ErrorMessages: [],
          Id: 0,
          // Index: 0,
          IsFreeFormText: IsFreeFormTextBox,
          NegativeMark: 0,
          PositiveMark: 1,
          // Mode: 1,
          MultiSelect: MultiSelect,
          QuestionType: IsFreeFormTextBox
            ? 3
            : ActiveQuestionType === 1
              ? MultiSelect
                ? 4
                : 1
              : ActiveQuestionType === 2
                ? 2
                : 0,
          Text: Question,
        };
      },
    );
    let scoreBandConfigs = shotclassData.addSurvey?.scoreBands?.map(
      (scoreband) => {
        return {
          MinScore: scoreband.minScore,
          MaxScore: scoreband.maxScore,
          FeedbackMessage: scoreband.feedbackMessage,
        };
      },
    );
    // const isExternalCourse = !!shotclassData?.details?.isExternalCourse;
    // const isExternalWebinarCourse =
    //   isExternalCourse &&
    //   !!shotclassData?.details?.TrainingType?.some(
    //     (trainingType) =>
    //       (typeof trainingType === "object" &&
    //         trainingType?.Name?.toLowerCase() === "webinar") ||
    //       (typeof trainingType === "string" &&
    //         trainingType?.toLowerCase() === "webinar"),
    //   );
    // const allowCertificateUpload =
    //   !isExternalWebinarCourse &&
    //   !!shotclassData?.publish?.AllowCertificateUpload;
    // const courseType = isExternalCourse ? "External" : "Internal";
    // const completionVerificationMode = isExternalCourse
    //   ? allowCertificateUpload
    //     ? "CertificateUploadAndApproval"
    //     : "SelfAttested"
    //   : undefined;
    // ✅ Exclude completion configuration and course completion duration from Other to prevent duplicates
    const {
      IsCustomCompletionEnabled,
      CompletionConfiguration,
      CourseCompletionDuration,
      coursecompletionduration,
      ...otherData
    } = shotclassData.Other;
    let data = {
      ...otherData,
      // ID: shotclassData.ID,
      ParentId: `${shotclassData.ShotclassId}`,
      Name: shotclassData.details.ShotClassName,
      ImageUrl:
        typeof shotclassData.details.ThumbnailImage === "string"
          ? shotclassData.details.ThumbnailImage
          : shotclassData.details.ThumbnailImage.MediaUri,
      // ImageFileSizeinKB: null,
      Description: shotclassData.details.Summary,
      KeyLearning: shotclassData.details.Description,
      VideoUrl:
        shotclassData.Other?.VideoUrl !==
        shotclassData.details.Content.ContentValue
          ? mediaType === 2 || mediaType === 8
            ? shotclassData.details.Content.ContentValue[0]?.link
            : ""
          : shotclassData.details.Content.ContentValue,
      // mediaType === 2 || mediaType === 8
      //   ?
      // shotclassData.details.Content.ContentMediaExtension === ""
      // ? // shotclassData.details.Content?.ContentValue ===
      // shotclassData?.Other?.VideoUrl
      // shotclassData.details.Content.ContentValue
      // : shotclassData.details.Content.ContentValue[0]?.link,
      // : ""
      VideoDuration:
        mediaType === 1
          ? shotclassData.Other?.VideoUrl ===
            shotclassData.details.Content.ContentValue
            ? shotclassData.Other?.VideoDuration
            : "00:00:00"
          : mediaType === 2
            ? shotclassData.Other?.VideoUrl !==
              shotclassData.details.Content.ContentValue
              ? shotclassData.details.Content.ContentValue[0].Duration
              : shotclassData.Other?.VideoDuration
            : null,
      VideoThumbnailUrl:
        typeof shotclassData.details.ThumbnailImage === "string"
          ? shotclassData.details.ThumbnailImage
          : shotclassData.details.ThumbnailImage.MediaUri,
      AssessmentSet: {
        ...shotclassData.Other.AssessmentSet,
        ParentId: shotclassData.Other.AssessmentSet.ID,
        Name: shotclassData.details.ShotClassName,
        // Description: "",
        // Duration: 1,
        // MaxScore: 100,
        MinScore:
          shotclassData.addQuiz.TotalQuestionCount > 0
            ? shotclassData.addQuiz.PassingMarks
              ? parseInt(shotclassData.addQuiz.PassingMarks)
              : ""
            : 0,
        // AllowReattempt: false,
        QuestionList:
          shotclassData.addQuiz.TotalQuestionCount > 0 ? quizQuestionList : [],
        // Locale: shotclassData.details.Language,
        // ParentId: 0,
        // ID: shotclassData.ID,
      },
      StatusText: shouldMarkProcessing
        ? "Processing"
        : status
          ? status
          : // (isContent && shotclassData.details.Content.ContentMediaExtension) ||
            shotclassData.Other?.VideoUrl !==
              shotclassData.details.Content.ContentValue
            ? // mediaType === 2 || mediaType === 8
              //   ? "Published"
              //   :
              "Saved"
            : "Published",
      // Credits: "",
      Tags: shotclassData.details.TagsList.map((tag) => tag.TagName).join(","),
      Status: shouldMarkProcessing
        ? 5
        : status
          ? status
          : // (isContent && shotclassData.details.Content.ContentMediaExtension) ||
            shotclassData.Other?.VideoUrl !==
              shotclassData.details.Content.ContentValue
            ? // mediaType === 2 || mediaType === 8
              //   ? "Published"
              //   :
              0
            : 1,
      VideoUploadStatus: shouldSetVideoNotAvailable
        ? 0
        : shotclassData.Other?.VideoUploadStatus,
      VideoUploadStatusText: shouldSetVideoNotAvailable
        ? "VideoNotAvailable"
        : shotclassData.Other?.VideoUploadStatusText,
      // Logo: "https://mlearn.blob.core.windows.net/shotclass/img/hp-logo.gif",
      // CategoryID: "",
      TrainingTypeId: shotclassData.details.TrainingType?.map(
        (training) => training.TypeId,
      ),
      // Type: "ShotClass",
      // ParentId: 0,
      Mediatype: mediaType,
      // MediaSource: "",
      // MoocCourseSubType: 0,
      Locale: shotclassData.details.Language,
      IsMediaDownloadable: shotclassData.publish.OfflineShotclass,
      IsClassDownloadable: shotclassData.publish.OfflineShotclass,
      IsRestrictedClass: shotclassData.publish.HasRestricted,
      IsVideoMandatory: shotclassData.publish.IsVideoMandatory,
      IsRandomQuestionAllowed: shotclassData.publish.QuestionJumbling,
      ShowCorrectAnswer: shotclassData.publish.ShowCorrectAnswers,
      LearnerChangeAnswerOptions: shotclassData.publish.CanChangeAnswers,
      // ...(!isExternalWebinarCourse && {
      //   AllowCertificateUpload: !!shotclassData.publish.AllowCertificateUpload,
      // }),
      // CourseType: courseType,
      // ...(completionVerificationMode && {
      //   CompletionVerificationMode: completionVerificationMode,
      // }),
      ShotclassTargetGroupMapping: shotclassData.publish.HasRestricted
        ? shotclassData.publish.ShotclassTargetGroupMapping?.map((tag) => {
            return { TargetGroupId: 1, TargetGroupMemberId: tag.UserGroupId };
          })
        : [],
      Survey:
        shotclassData.addSurvey.TotalQuestionCount > 0
          ? shotclassData.Other?.Survey
            ? (() => {
                // ✅ Destructure and exclude unwanted properties
                const { IsTrackingEnabled, ...cleanSurvey } =
                  shotclassData.Other.Survey;
                return {
                  ...cleanSurvey,
                  IsMandatory: shotclassData.publish.IsSurveyMandatory,
                  Questions:
                    shotclassData.addSurvey.TotalQuestionCount > 0
                      ? surveyQuestionList
                      : [],
                  Type: shotclassData.addSurvey.surveyType === "scored" ? 1 : 0,
                  // ✅ Add ScoreBandConfigs only for scored surveys
                  ...(shotclassData.addSurvey.surveyType === "scored" && {
                    scoreBandConfigs: scoreBandConfigs,
                    IsTrackingEnabled: shotclassData.publish.IsTrackingEnabled,
                  }),
                };
              })()
            : {
                SurveyId: "",
                Locale: shotclassData.details.Language,
                ShotClassId: shotclassData?.ShotclassId,
                IsMandatory: shotclassData.publish.IsSurveyMandatory,
                Questions:
                  shotclassData.addSurvey.TotalQuestionCount > 0
                    ? surveyQuestionList
                    : [],
                Type: shotclassData.addSurvey.surveyType === "scored" ? 1 : 0,
                // ✅ Add ScoreBandConfigs only for scored surveys
                ...(shotclassData.addSurvey.surveyType === "scored" && {
                  scoreBandConfigs: scoreBandConfigs,
                  IsTrackingEnabled: shotclassData.publish.IsTrackingEnabled,
                }),
              }
          : null,
      ShotClassType: shotClassType
        ? shotClassType
        : shotclassData.publish.LearningContentOnly,
      // ✅ Add completion configuration for copy operation (dynamic values only)
      ...(shotclassData.publish.isCustomCompletionEnabled &&
        shotclassData.publish.completionConfiguration && {
          isCustomCompletionEnabled:
            shotclassData.publish.isCustomCompletionEnabled,
          completionConfiguration:
            shotclassData.publish.completionConfiguration,
        }),
    };
    return await apis.manage
      .copyShotclass(data)
      .then((response) => {
        if (response?.data) {
          const classId = response?.data.split(":")[1].trim();
          const shotclassName = shotclassData?.details?.ShotClassName;
          const fileData = shotclassData.details.Content.ContentValue[0];
          const fileName = fileData?.name;
          const fileSize = fileData?.size;
          const fileExtension =
            shotclassData.details.Content.ContentMediaExtension;
          const classStatus = shotclassData.Other?.Status;
          // const isVideoProcessed =
          //   Number(shotclassData.Other?.VideoUploadStatus) === 3 ||
          //   shotclassData.Other?.VideoUploadStatus === "Processed";
          if (
            shotclassData.details.TrainingType?.[0]?.Name?.toLowerCase() ===
              "webinar" &&
            fileData &&
            //Checking if the calander file is modified or not
            shotclassData.details.CalendarUrl &&
            Array.isArray(shotclassData.details.CalendarUrl) &&
            shotclassData.details.CalendarUrl.length > 0 &&
            shotclassData.details.CalendarUrl[0]
          ) {
            const calanderFileData = shotclassData.details.CalendarUrl[0];
            const calanderFileExtension = ".ics";
            dispatch(
              uploadCalanderFileActionHandler(
                classId,
                calanderFileExtension,
                calanderFileData,
              ),
            );
          }
          if (
            shotclassData.Other?.VideoUrl !==
              shotclassData.details.Content.ContentValue ||
            shouldQueueExistingVideo
            // (fileData && fileExtension) ||
            // mediaType === 5 ||
            // mediaType === 2 ||
            // mediaType === 8
          ) {
            if (mediaType === 1) {
              if (shouldQueueExistingVideo) {
                const shotClassID = shotclassData?.ShotclassId;
                return dispatch(
                  getStoredMediaInfoActionHandler(shotClassID),
                ).then((classData) => {
                  if (!classData) {
                    return true;
                  }
                  const blobName =
                    classData?.BlobName || shotclassData?.Other?.VideoUrl || "";
                  const blobFileSize = classData?.FileSize;
                  return dispatch(
                    addToQueueVideoActionHandler(
                      blobName,
                      parseInt(classId, 10),
                      effectiveStatus,
                      blobFileSize,
                    ),
                  );
                });
              } else if (
                shotclassData.Other?.VideoUrl !==
                shotclassData.details.Content.ContentValue
              ) {
                const blockLength = 1048576;
                const blockCount = Math.ceil(fileSize / blockLength);

                return dispatch(getStoredMediaInfoActionHandler(classId))
                  .then((classData) => {
                    if (
                      classData &&
                      shotclassData.Other?.VideoUploadStatus !== 3
                    ) {
                      const blobName =
                        classData?.BlobName ||
                        shotclassData?.Other?.VideoUrl ||
                        "";
                      const blobFileSize = classData?.FileSize;
                      return dispatch(
                        addToQueueVideoActionHandler(
                          blobName,
                          parseInt(classId, 10),
                          status ? status : "Published",
                          blobFileSize,
                        ),
                      ).then(() => {
                        return dispatch(
                          setMetaDataForVideoActionHandler(
                            blockCount,
                            fileName,
                            fileSize,
                            shotclassName,
                          ),
                        );
                      });
                    } else {
                      return dispatch(
                        setMetaDataForVideoActionHandler(
                          blockCount,
                          fileName,
                          fileSize,
                          shotclassName,
                        ),
                      );
                    }
                  })
                  .then((data) => {
                    let uploadChunkObject = {
                      videoGuid: data?.VideoGuid,
                      // classId: classId,
                      classId: response?.data,
                      isVariant: false,
                      status: status ? status : "Published",
                      fileName: fileName,
                      url: "uploading",
                      fileSize: fileSize,
                      blockLength: blockLength,
                      blockCount: blockCount,
                      uploadStatusMessage: "xsadsd",
                      isUploadCompleted: false,
                      isShotClassSourcingFromLearner: false,
                      file: fileData,
                    };
                    const videoItem = {
                      id: classId,
                      name: fileName,
                      totalChunk: blockCount,
                      completedChunk: 0,
                      className: shotclassName,
                      currentStatus: videoUploadStatus.PENDING,
                      chunkObject: uploadChunkObject,
                    };
                    const videoList =
                      getState()?.manageReducer?.videoUploadList;
                    const updatedVideoList = [videoItem, ...videoList];
                    dispatch(setUpdateVideoListAction(updatedVideoList));

                    dispatch(
                      uploadVideoChunkActionHandler(uploadChunkObject, classId),
                    );
                    return "video";
                  });
              } else {
                return true;
              }
            } else if (mediaType === 3) {
              return dispatch(
                uploadPptShotClassActionHandler(
                  classId,
                  fileExtension,
                  false,
                  status ? status : "Published",
                  fileData,
                ),
              );
            } else if (mediaType === 5 || mediaType === 2 || mediaType === 8) {
              return dispatch(
                uploadSlideShareActionHandler(
                  classId,
                  mediaType === 2 ? fileData?.Duration : "00:00:00",
                  status ? status : "Published",
                  fileData,
                ),
              );
            } else if (mediaType === 7) {
              return dispatch(
                uploadPdfShotClassActionHandler(
                  classId,
                  fileExtension,
                  false,
                  status ? status : "Published",
                  fileData,
                ),
              );
            } else if (mediaType === 9 || mediaType === 11) {
              let isHTML = mediaType === 11 ? true : false;
              return dispatch(
                uploadScormOrHtmlShotClassActionHandler(
                  isHTML,
                  classId,
                  fileExtension,
                  fileName,
                  false,
                  status ? status : "Published",
                  fileData,
                ),
              );
            }
          } else {
            return true;
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getStoredMediaInfoActionHandler = (classId) => async () => {
  return await apis.manage
    .getStoredMediaInfo(classId)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const setMetaDataForVideoActionHandler =
  (numberOfBlocks, fileName, fileSize, className) => async () => {
    return await apis.manage
      .setMetaDataForVideo(
        numberOfBlocks,
        encodeURIComponent(fileName),
        fileSize,
        className,
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const addToQueueVideoActionHandler =
  (blobName, classId, status, blobFileSize) => async () => {
    const data = {
      blobName: blobName,
      classId: classId,
      fileSize: blobFileSize,
      isVariant: false,
      status: status,
    };
    return await apis.manage
      .addToQueueVideo(data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const userCancelledVideoUploadActionHandler = (strGuid) => async () => {
  return await apis.manage
    .userCancelledVideoUpload(strGuid)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const uploadVideoChunkActionHandler =
  (uploadChunkObject, classId) => async (dispatch, getState) => {
    let currentChunk = 1;
    let start = 0;
    let end = Math.min(
      uploadChunkObject.blockLength,
      uploadChunkObject.fileSize,
    );
    dispatch(setShowVideoUploadListPanelAction(true));

    const uploadChunk = async () => {
      let slicedData = uploadChunkObject.file.slice(start, end);
      const formData = new FormData();
      formData.append("Slice", slicedData);
      // console.log(slicedData);
      return await apis.manage
        .uploadVideoChunk(currentChunk, uploadChunkObject, formData)
        .then((response) => {
          // console.log(response.data);
          if (currentChunk <= uploadChunkObject.blockCount) {
            const videoList = getState()?.manageReducer?.videoUploadList;
            const videoItem = videoList?.find((video) => video?.id === classId);
            const updatedVideoList = videoList?.map((video) => {
              if (video?.id === classId) {
                return {
                  ...video,
                  completedChunk: currentChunk,
                  currentStatus:
                    currentChunk === uploadChunkObject.blockCount
                      ? videoUploadStatus.COMPLETED
                      : videoUploadStatus.PENDING,
                };
              }
              return video;
            });
            dispatch(setUpdateVideoListAction(updatedVideoList));
            currentChunk++;
            start = (currentChunk - 1) * uploadChunkObject.blockLength;
            end = Math.min(
              currentChunk * uploadChunkObject.blockLength,
              uploadChunkObject.fileSize,
            );
            if (videoItem?.currentStatus === videoUploadStatus?.CANCELLED) {
              const updatedVideoList = videoList?.map((video) => {
                if (video?.id === classId) {
                  return {
                    ...video,
                    completedChunk: 0,
                    currentStatus: videoUploadStatus.CANCELLED,
                  };
                }
                return video;
              });
              dispatch(setUpdateVideoListAction(updatedVideoList));
              // dispatch(
              //   setErrorHandler(
              //     errorTypes.SUCCESS,
              //     `Your Shotclass ${videoItem?.className} will be published shortly. Meanwhile your recently created shotclass is available in Manage Shotclass page for review.`
              //     )
              //     );
              return false;
            } else if (response?.data?.IsLastBlock) {
              if (uploadChunkObject?.status === "Published") {
                dispatch(
                  setErrorHandler(
                    errorTypes.SUCCESS,
                    `Your Shotclass ${videoItem?.className} will be published shortly. Meanwhile your recently created shotclass is available in Manage Shotclass page for review.`,
                  ),
                );
              } else {
                dispatch(
                  setErrorHandler(
                    errorTypes.SUCCESS,
                    `Your Shotclass ${videoItem?.className} is saved successfully.`,
                  ),
                );
              }
              return true;
            } else {
              return uploadChunk();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    const isUploadChunkDone = await uploadChunk();
    return isUploadChunkDone;
  };

export const uploadPptShotClassActionHandler =
  (classId, fileExtension, isVariant, status, fileData) => async () => {
    const formData = new FormData();
    formData.append("file", fileData);
    return await apis.manage
      .uploadPptShotClass(classId, fileExtension, isVariant, status, formData)
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const uploadPdfShotClassActionHandler =
  (classId, fileExtension, isVariant, status, fileData) => async () => {
    const formData = new FormData();
    formData.append("file", fileData);

    return await apis.manage
      .uploadPdfShotClass(classId, fileExtension, isVariant, status, formData)
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const uploadScormOrHtmlShotClassActionHandler =
  (isHTML, classId, fileExtension, fileName, isVariant, status, fileData) =>
  async () => {
    const formData = new FormData();
    formData.append("file", fileData);

    return await apis.manage
      .uploadScormOrHtmlShotClass(
        isHTML,
        classId,
        fileExtension,
        fileName,
        isVariant,
        status,
        formData,
      )
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getVideoMediaTokenActionHandler = (assetId) => async () => {
  return await apis.manage
    .getVideoMediaToken(assetId)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSemanticSectionsByIdActionHandler =
  (shotclassId) => async (dispatch) => {
    dispatch(
      loaders.manage.manageTransciption.getTranscriptionDataLoader(true),
    );
    return await apis.manage
      .getSemanticSectionsById(shotclassId)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(
          loaders.manage.manageTransciption.getTranscriptionDataLoader(false),
        );
      });
  };
export const getSemanticClassByIdActionHandler = (shotclassId) => async () => {
  return await apis.manage
    .getSemanticClassById(shotclassId)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateTranscribeShotclassActionHandler = (data) => async () => {
  return await apis.manage
    .updateTranscribeShotclass(data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const uploadCalanderFileActionHandler =
  (classId, fileExtension, fileData) => async (dispatch) => {
    const formData = new FormData();
    formData.append("file", fileData);

    await apis.manage
      .uploadCalanderFile(classId, fileExtension, formData)
      .then((response) => {
        if (response.status === 200) {
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, `${response?.data.Message}`),
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
